import * as React from 'react';
import '../../Assets/styles/accordion.css';

interface AccordionItemProps {
    id: number;
    opened: boolean;
    paragraph?: string;
    title: string | any;
    element?: any;
    handleClick: (id: number) => void;
}

export class AccordionItem extends React.Component<AccordionItemProps, {}> {
    constructor(props: AccordionItemProps) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    public onClick() {
        const { id, handleClick } = this.props;
        handleClick(id);
    }

    public render() {
        const { paragraph, title, opened, element } = this.props;
        return (
            <div className={`accordion-item, ${opened && 'accordion-item--opened'}`}>
                <div className="accordion-item__line" onClick={this.onClick}>
                    {
                        (typeof title === 'string') ?
                        <h3 className="accordion-item__title" dangerouslySetInnerHTML={{__html: title}} /> :
                        <h3 className="accordion-item__title">
                            {title}
                        </h3>
                    }
                    <span className="accordion-item__icon" />
                </div>
                {   opened ?
                    <div className="accordion-item__inner">
                        <div className="accordion-item__content">
                        {
                            paragraph ?
                            <div className="accordion-item__contentPadding">
                                <p className="accordion-item__paragraph" dangerouslySetInnerHTML={{__html: paragraph}} />
                            </div> :
                            element
                        }
                        </div>
                    </div> :
                    undefined
                }
            </div>
        );
    }
}
